/*
 * Action Types
 */
export enum EmployeesTypes {
  LIST_EMPLOYEES_REQUEST = '@employees/LIST_EMPLOYEES_REQUEST',
  LIST_EMPLOYEES_SUCCESS = '@employees/LIST_EMPLOYEES_SUCCESS',
  LIST_EMPLOYEES_FAILURE = '@employees/LIST_EMPLOYEES_FAILURE',

  LIST_INACTIVE_EMPLOYEES_REQUEST = '@employees/LIST_INACTIVE_EMPLOYEES_REQUEST',
  LIST_INACTIVE_EMPLOYEES_SUCCESS = '@employees/LIST_INACTIVE_EMPLOYEES_SUCCESS',
  LIST_INACTIVE_EMPLOYEES_FAILURE = '@employees/LIST_INACTIVE_EMPLOYEES_FAILURE',

  FILTER_EMPLOYEES_REQUEST = '@employees/FILTER_EMPLOYEES_REQUEST',
  FILTER_EMPLOYEES_SUCCESS = '@employees/FILTER_EMPLOYEES_SUCCESS',
  FILTER_EMPLOYEES_FAILURE = '@employees/FILTER_EMPLOYEES_FAILURE',

  GET_EMPLOYEE_REQUEST = '@employees/GET_EMPLOYEE_REQUEST',
  GET_EMPLOYEE_SUCCESS = '@employees/GET_EMPLOYEE_SUCCESS',
  GET_EMPLOYEE_FAILURE = '@employees/GET_EMPLOYEE_FAILURE',

  CREATE_EMPLOYEE_REQUEST = '@employees/CREATE_EMPLOYEE_REQUEST',
  CREATE_EMPLOYEE_SUCCESS = '@employees/CREATE_EMPLOYEE_SUCCESS',
  CREATE_EMPLOYEE_FAILURE = '@employees/CREATE_EMPLOYEE_FAILURE',

  UPDATE_EMPLOYEE_REQUEST = '@employees/UPDATE_EMPLOYEE_REQUEST',
  UPDATE_EMPLOYEE_SUCCESS = '@employees/UPDATE_EMPLOYEE_SUCCESS',
  UPDATE_EMPLOYEE_FAILURE = '@employees/UPDATE_EMPLOYEE_FAILURE',

  DELETE_EMPLOYEE_REQUEST = '@employees/DELETE_EMPLOYEE_REQUEST',
  DELETE_EMPLOYEE_SUCCESS = '@employees/DELETE_EMPLOYEE_SUCCESS',
  DELETE_EMPLOYEE_FAILURE = '@employees/DELETE_EMPLOYEE_FAILURE',

  DELETE_LIST_EMPLOYEE_REQUEST = '@employees/DELETE_LIST_EMPLOYEE_REQUEST',
  DELETE_LIST_EMPLOYEE_SUCCESS = '@employees/DELETE_LIST_EMPLOYEE_SUCCESS',
  DELETE_LIST_EMPLOYEE_FAILURE = '@employees/DELETE_LIST_EMPLOYEE_FAILURE',

  CHANGE_PASSWORD_REQUEST = '@employees/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS = '@employees/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE = '@employees/CHANGE_PASSWORD_FAILURE',

  GET_EMPLOYEES_REPORT_REQUEST = '@employees/GET_EMPLOYEES_REPORT_REQUEST',
  GET_EMPLOYEES_REPORT_SUCCESS = '@employees/GET_EMPLOYEES_REPORT_SUCCESS',
  GET_EMPLOYEES_REPORT_FAILURE = '@employees/GET_EMPLOYEES_REPORT_FAILURE',

  GET_EMPLOYEES_DAILY_REPORT_REQUEST = '@employees/GET_EMPLOYEES_DAILY_REPORT_REQUEST',
  GET_EMPLOYEES_DAILY_REPORT_SUCCESS = '@employees/GET_EMPLOYEES_DAILY_REPORT_SUCCESS',
  GET_EMPLOYEES_DAILY_REPORT_FAILURE = '@employees/GET_EMPLOYEES_DAILY_REPORT_FAILURE',

  ADD_EMPLOYEE_PAYMENT_REQUEST = '@employees/ADD_EMPLOYEE_PAYMENT_REQUEST',
  ADD_EMPLOYEE_PAYMENT_SUCCESS = '@employees/ADD_EMPLOYEE_PAYMENT_SUCCESS',
  ADD_EMPLOYEE_PAYMENT_FAILURE = '@employees/ADD_EMPLOYEE_PAYMENT_FAILURE',

  REMOVE_EMPLOYEE_PAYMENT_REQUEST = '@employees/REMOVE_EMPLOYEE_PAYMENT_REQUEST',
  REMOVE_EMPLOYEE_PAYMENT_SUCCESS = '@employees/REMOVE_EMPLOYEE_PAYMENT_SUCCESS',
  REMOVE_EMPLOYEE_PAYMENT_FAILURE = '@employees/REMOVE_EMPLOYEE_PAYMENT_FAILURE',

  SET_SELECTED_COLLECTION = '@employees/SET_SELECTED_COLLECTION',

  CREATE_MANY_EMPLOYEE_REQUEST = '@employees/CREATE_MANY_EMPLOYEE_REQUEST',
  CREATE_MANY_EMPLOYEE_SUCCESS = '@employees/CREATE_MANY_EMPLOYEE_SUCCESS',
  CREATE_MANY_EMPLOYEE_FAILURE = '@employees/CREATE_MANY_EMPLOYEE_FAILURE',

  GET_EMPLOYEE_SETTINGS_REQUEST = '@employees/GET_EMPLOYEE_SETTINGS_REQUEST',
  GET_EMPLOYEE_SETTINGS_SUCCESS = '@employees/GET_EMPLOYEE_SETTINGS_SUCCESS',
  GET_EMPLOYEE_SETTINGS_FALURE = '@employees/GET_EMPLOYEE_SETTINGS_FALURE',

  UPDATE_EMPLOYEE_SETTINGS_REQUEST = '@employees/UPDATE_EMPLOYEE_SETTINGS_REQUEST',
  UPDATE_EMPLOYEE_SETTINGS_SUCCESS = '@employees/UPDATE_EMPLOYEE_SETTINGS_SUCCESS',
  UPDATE_EMPLOYEE_SETTINGS_FALURE = '@employees/UPDATE_EMPLOYEE_SETTINGS_FALURE',

  EMPLOYEE_RESTRICTION_LIST_REQUEST = '@employees/EMPLOYEE_RESTRICTION_LIST_REQUEST',
  EMPLOYEE_RESTRICTION_LIST_SUCCESS = '@employees/EMPLOYEE_RESTRICTION_LIST_SUCCESS',
  EMPLOYEE_RESTRICTION_LIST_FALURE = '@employees/EMPLOYEE_RESTRICTION_LIST_FALURE',

  EMPLOYEE_RATING_REQUEST = '@employees/EMPLOYEE_RATING_REQUEST',
  EMPLOYEE_RATING_SUCCESS = '@employees/EMPLOYEE_RATING_SUCCESS',
  EMPLOYEE_RATING_FALURE = '@employees/EMPLOYEE_RATING_FALURE',
}

/*
 * Data types
 */
export interface EmployeeInterface {
  id: string;
  type: number;
  name: string;
  phone: string;
  registry: string;
  externalId?: string;
  document: string;
  licenseNumber?: string;
  licenseType?: string;
  picture?: string;
  licenseExpiration?: string;
  licenseFrontPhoto?: string;
  licenseBackPhoto?: string;
  createdAt: string;
  updatedAt: string;
  testOnly: boolean;
  status: string;
  averageEvaluation?: number | null;
}

export interface EmployeeReportInterface {
  [key: string]: {
    'Perfil Comum': number;
    Externa: number;
    'Nova politica': number;
    'Politica de teste': number;
    total: string | number;
    comission: string | number;
    transportOperatorId?: string;
  };
}

export interface EmployeeDailyReportInterface {
  usedDate: string | null;
  transactioned: number;
  commissioned: number;
  expected: number;
  paid: number;
  owned: number;
}

export interface AddPaymentInterface {
  amount: number;
  externalId: string;
  description: string;
  tripIds: Array<string>;
  exceededMoneyTripId: string;
  employeeId: string;
  paymentDate: Date | number;
}

type SingleTicketProfileParam = {
  facial: boolean;
  needed: boolean;
  documents: string[];
};

export interface EmployeeSettingsInterface {
  id: string;
  days: number | null;
  trips: number;
  value: number;
  commissionType: number | null;
  commissionPaymentRule: number | null;
  commissionValue: number | null;
  singleTicketProfiles?: string[];
  singleTicketProfileParams?: Record<string, SingleTicketProfileParam>;
  createdAt: string;
  updatedAt: string;
  paymentMethods: string[] | null;
  hasTicketRegister: boolean;
}
export interface EmployeeRatingInterface {
  tripId: string;
  tripTitle: string;
  entryValue: number;
  entryUsedAt: string;
  entryUsedDate: string;
  benefitName: string | null;
  tripEvaluation: number;
  lineSectionName: string;
  lineColor: string;
  carPrefix: string;
  employeeId: string;
  employeeName: string;
}

/*
 * State type
 */
export interface EmployeesState {
  readonly employeesList: EmployeeInterface[];
  readonly manyEmployeesList: EmployeeInterface[];
  readonly inactiveEmployeesList: EmployeeInterface[];
  readonly filterEmployeesList: EmployeeInterface[];
  readonly employeeData: EmployeeInterface;
  readonly employeesReports: EmployeeReportInterface;
  readonly employeesDailyReports: EmployeeDailyReportInterface[];
  readonly selectedCollection: number | null;
  readonly employeeSettingsData: EmployeeSettingsInterface;
  readonly employeeRestrictionList: any[];
  readonly employeeRating: EmployeeRatingInterface[];
  readonly totalCount: number;
  readonly totalCountInactive: number;
  readonly loading: boolean;
  readonly error: boolean;
}
